// Free personal mailboxes the NHS sign-up page (/auth/nhs-register) turns away.
// Mirrors utils/profile.py in bevan-backend, which enforces the same rule; this
// copy only gives the user the message before they submit.
const PERSONAL_EMAIL_DOMAINS = ['gmail.com', 'googlemail.com', 'icloud.com'];
// Matched on the domain's first part, so country variants count too (yahoo.co.uk, hotmail.fr ...).
const PERSONAL_EMAIL_PROVIDERS = ['yahoo', 'hotmail', 'outlook', 'live', 'aol'];

export const PERSONAL_EMAIL_MESSAGE = "The free trial is currently available to NHS users only.";

export const isPersonalEmail = (email) => {
    const domain = (email || '').split('@').pop().trim().toLowerCase().replace(/\.$/, '');
    return PERSONAL_EMAIL_DOMAINS.includes(domain) || PERSONAL_EMAIL_PROVIDERS.includes(domain.split('.')[0]);
};
